import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const URL = API_URL + "/organization";
const VERSION = 0;

export type UpdateOrganizationResponse = {
    organizationId: string;
    organizationName: string;
    timeCreated: number;
};

export default async function updateOrganization(organizationName: string): Promise<UpdateOrganizationResponse> {
    const options: httpNetworking.PUTRequestConfig = {
        timeout: 50000
    };
    const params = {
        organizationName
    };

    const response = (await httpNetworking.simplePUTRequest(URL, params, options, VERSION)).data;
    return response;
}
